export const Legend = {
  success: 'success',
  error: 'error',
  noConnection: 'no_connection',
  virtual: 'virtual',
};
